// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Bdb1","item":"PaymentsMobile_item__rnwuY","label":"PaymentsMobile_label__1LOCR","amount":"PaymentsMobile_amount__2zJxg"};